import { render } from "./add-pra_pelaksanaan_instruktur.vue?vue&type=template&id=36cc6bcd"
import script from "./add-pra_pelaksanaan_instruktur.vue?vue&type=script&lang=js"
export * from "./add-pra_pelaksanaan_instruktur.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__